module.exports = __webpack_public_path__ + "img/bg_main.55815e80.svg";